import React, { useState, useEffect } from 'react';
import { Container, Image, Dropdown } from "react-bootstrap";
import axios from 'axios';

// Import gallery
import loginPhoto from '../../../assets/images/common/loginPhoto.png';

// Icons
import { FaSignOutAlt } from "react-icons/fa";


// CSS
import '../header/header.css';
import PageInfoStatus from "../pageInfoStatus/pageInfoStatus";

const Header = () => {
  const userData = sessionStorage.getItem('user');
  const userObj = userData ? JSON.parse(userData) : {};
  const [avatarUrl, setAvatarUrl] = useState(null);

  const handleLogout = () => {
    sessionStorage.removeItem('user');
    window.location.href = '/';
  };

  useEffect(() => {
    const fetchProfilePhoto = async () => {
      if (!userObj?.user_id) return;
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const response = await axios.get(`${baseUrl}/main/getemployeeprofilephoto`, {
          params: { _emp_id: userObj.user_id }
        });
        if (response.data && response.data.length > 0) {
          const photo = response.data[0].profile_photo;
          if (photo) {
            const trimmedPhoto = photo.trim();
            if (trimmedPhoto.startsWith('data:image/') || trimmedPhoto.startsWith('data:application/')) {
              setAvatarUrl(trimmedPhoto);
            } else if (/^[a-zA-Z0-9+/=]+$/.test(trimmedPhoto) && trimmedPhoto.length > 100) {
              setAvatarUrl(`data:image/png;base64,${trimmedPhoto}`);
            } else {
              setAvatarUrl(`${baseUrl}/uploads/get-image/${trimmedPhoto}`);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching employee profile photo:', error);
      }
    };

    fetchProfilePhoto();
  }, [userObj?.user_id]);

  return (
    <Container fluid className='topNav'>
      <div className="pageInfoStatusSubHead">
        <PageInfoStatus />
      </div>

      <div className='rightNavigations'>
        <div className='profileInfo'>
          <div className='profileInfoLeft'>
            <h6 className='user'>{userObj.user_name}</h6>
            <p className='role'>{userObj.role_name}</p>
          </div>
          
          <div className='profileInfoRight'>
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="link"
                bsPrefix="p-0 border-0 shadow-none"
                id="dropdown-basic"
              >
                <Image src={avatarUrl || loginPhoto} alt="Account Background" fluid />
              </Dropdown.Toggle>

              <Dropdown.Menu className="shadow-sm">
                <Dropdown.Item onClick={handleLogout}>
                  <FaSignOutAlt className="me-2" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Header;

